<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PA11.w.1.0.0"></a></div>
<div class="flow" style="">
<a class="page" id="ORIG-GBS.PA11"></a>
<div class="gtxt_body" id="block.14.0.0.box.424.450.829.102.q.90" style="margin-bottom: 1.5em;">
<a id="ORIG-GBS.PA11.w.0.0.0"></a><p class="gtxt_body gtxt_heading" id="para.14.0.0.box.424.450.829.102.q.90" style="text-indent:0;color:rgb(0, 0, 0);">Acknowledgments</p>
</div>
<div class="gtxt_body" id="block.14.1.0.box.197.821.1286.589.q.60">
<a id="ORIG-GBS.PA11.w.1.0.0"></a><p class="gtxt_body" id="para.14.1.0.box.197.821.1286.372.q.60" style="text-indent:1em;">My book is a story about New Orleanians an<a id="GBS.PA11.w.1.1.0"></a>d Louisianians . . . and people everywhere. A ghost writer almost certainly would write more eloquently than I, but I feared that some of the passion that my wife, Mary, and I feel for the people of our city and our state inevitably would be lost. So, I decided that every single word, thought, and experience herein would originate with this passionate New Orleanian and Louisianian.</p>
<a id="ORIG-GBS.PA11.w.1.1.0"></a><p class="gtxt_body" id="para.14.1.1.box.197.1201.1285.209.q.50" style="text-indent:1em;"><a id="GBS.PA11.w.1.2.0"></a>This book would not have been written without the assistance and constant encouragem<a id="GBS.PA11.w.2.0.0"></a>ent of my distinguished nephew, Julian L. McPhillips, Jr., a pr<a id="GBS.PA12"></a><a id="GBS.PA12.w.0.0.0"></a>ominent Montgomery, Alabama, attorney. I do not have a better friend, anywhere.</p>
</div>
</div>
<div class="flow" style="">
</div>
<div style="display:none;"><a id="GBS.PA12.w.0.0.0.1"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-0009.vue?36334dd6